import React, {Component} from 'react';
import Header from './../Layout/Header';
import Footer from './../Layout/Footer2';
import { Helmet } from 'react-helmet';
import ByState from './../Element/ByState';

class AllJobsByState extends Component {
    render() {
        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Remote Jobs by State | Work From Home Opportunities in USA | OpenToWorkRemote</title>
                    <meta name="description" content="Find remote jobs and work from home opportunities across all 50 US states. Search remote positions by state, including California, Texas, New York, Florida, and more. Updated daily. #RemoteWork #WorkFromHome" />
                    <meta name="keywords" content="remote jobs by state, work from home USA states, remote work opportunities by state, remote positions USA, remote career states, remote employment locations, virtual jobs by state" />
                    <meta property="og:title" content="Remote Jobs by State | OpenToWorkRemote" />
                    <meta property="og:description" content="Find remote jobs and work from home opportunities across all 50 US states. Search remote positions by state." />
                    <link rel="canonical" href="https://www.opentoworkremote.com/all-jobs-by-state" />
                </Helmet>

                <ByState />

                <Footer />
            </div>
        );
    }
};

export default AllJobsByState;
